import { DOSSIERS_QUERY_KEY, invalidateOpenDossiersQueries, useUpdateDossierPropertyQueriesData } from "@/entities/dossier";
import { Vsm } from "@/entities/vsm/domain/vsm.ts";
import { useApiClient } from "@/infrastructure/rest";
import { useRealtimeTopic, VsmEvent } from "@/infrastructure/rsocket";
import { PutVsmDto, VsmDto } from "@/shared/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { VSM_QUERY_KEY } from "./constants.ts";

export function useGetDossierVsmById(id: string) {
    const apiClient = useApiClient();

    return useQuery({
        queryKey: [DOSSIERS_QUERY_KEY, id, VSM_QUERY_KEY],
        queryFn: async () => {
            const data = await apiClient.get<VsmDto>(`/dossiers/${id}/vsm`);
            return data ? Vsm.fromDto(data) : null;
        },
    });
}

type PutDossierVsm = PutVsmDto & {
    dossierId: string;
};

export function usePutDossierVsmById() {
    const apiClient = useApiClient();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ dossierId, ...data }: PutDossierVsm) => {
            await apiClient.put(`/dossiers/${dossierId}/vsm`, data);
        },
        onSuccess: async (_, variables) => {
            await invalidateOpenDossiersQueries(queryClient, variables.dossierId);
        },
        onError: (error) => {
            console.error("Error puting dossier vsm:", error);
        },
    });
}

export function useRealtimeVsm() {
    const { handleEvent } = useUpdateDossierPropertyQueriesData("vsm");

    useRealtimeTopic<VsmEvent>("vsm", {
        onMessage: (message) => {
            const { vsm, dossierId, reason } = message;
            handleEvent(dossierId, vsm.id, reason, Vsm.fromDto(vsm));
        },
    });
}
